<div
  class="flex py-28 flex-col md:items-center px-8 md:px-16 lg:px-24 xl:px-32 gap-6 md:gap-14 lg:gap-20 xl:gap-28"
  [ngClass]="{
    'md:flex-row-reverse': sideBySideCarouselAndDynamicTextData.rightCarousel,
    'md:flex-row': !sideBySideCarouselAndDynamicTextData.rightCarousel,
    'bg-white': sideBySideCarouselAndDynamicTextData.theme === 'light',
  }"
>
  @for (
    item of sideBySideCarouselAndDynamicTextData.items;
    track imgTackBy(i, item);
    let i = $index
  ) {
    @if (currentIndex() === i) {
      <div class="md:basis-1/2 shrink-0">
        @if (item?.video) {
          <div
            class="w-full aspect-video overflow-hidden rounded-xl md:rounded-2xl relative"
          >
            <div #video class="absolute inset-0 w-full h-full"></div>
            @if ((playClicked$ | async) === false) {
              @if (item?.customVideoThumbnail) {
                <ss-www-image-with-loader
                  class="w-full h-full"
                  [fileDetail]="item.customVideoThumbnail"
                  desktopImageSize="half"
                ></ss-www-image-with-loader>
              }
              <ss-www-play-button-overlay
                (playClicked)="bigPlayButtonClicked()"
              ></ss-www-play-button-overlay>
            }
          </div>
        }
        @if (item.image && !item?.video) {
          @if (item.imageLink) {
            @if (item.imageLink?.startsWith('/')) {
              <a [routerLink]="[item.imageLink]">
                <ss-www-image-with-loader
                  class="w-full aspect-video rounded-xl md:rounded-2xl hover:drop-shadow-lg transition-shadow duration-300 hover:scale-[1.02] hover:border-2 hover:border-ss-gold"
                  [fileDetail]="item.image"
                  desktopImageSize="half"
                />
              </a>
            } @else {
              <a [href]="item.imageLink">
                <ss-www-image-with-loader
                  class="w-full aspect-video rounded-xl md:rounded-2xl hover:drop-shadow-lg transition-shadow duration-300 hover:scale-[1.02] hover:border-2 hover:border-ss-gold"
                  [fileDetail]="item.image"
                  desktopImageSize="half"
                />
              </a>
            }
          } @else {
            <ss-www-image-with-loader
              class="w-full aspect-video rounded-xl md:rounded-2xl"
              [fileDetail]="item.image"
              desktopImageSize="half"
            />
          }
        }
      </div>
    }
    @if (currentIndex() === i) {
      <div class="flex flex-col grow justify-center md:justify-start">
        <div
          [innerHTML]="item.textContent"
          [ngClass]="{
            'text-[#776B62] text-center md:text-start':
              sideBySideCarouselAndDynamicTextData.theme === 'light',
          }"
          [ssDirectus]="{
            collection: 'sideBySideCarouselDynamicTextItems',
            item: item.id,
            fields: ['textContent'],
          }"
        ></div>
        <ss-www-carousel-controls
          class="block mt-4 md:w-fit"
          [currentIndex]="currentIndex()"
          [theme]="sideBySideCarouselAndDynamicTextData.theme"
          [items]="sideBySideCarouselAndDynamicTextData.items"
          (nextIndex)="setIndex($event)"
        ></ss-www-carousel-controls>
      </div>
    }
  }
</div>
